function select(element) {
  let selectedText;

  if (element.nodeName === "SELECT") {
    element.focus();

    selectedText = element.value;
  } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
    const isReadOnly = element.hasAttribute("readonly");

    if (!isReadOnly) {
      element.setAttribute("readonly", "");
    }

    element.select();
    element.setSelectionRange(0, element.value.length);

    if (!isReadOnly) {
      element.removeAttribute("readonly");
    }

    selectedText = element.value;
  } else {
    if (element.hasAttribute("contenteditable")) {
      element.focus();
    }

    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);

    selectedText = selection.toString();
  }

  return selectedText;
}

/**
 * @param {HTMLElement} target
 * @param {HTMLElement} trigger
 */
export default function copy({ target, trigger }) {
  let succeeded;
  if (typeof target === "undefined") {
    throw new Error('Invalid "target" value, use a valid Element');
  } else if (target && typeof target === "object" && target.nodeType === 1) {
    if (target.hasAttribute("disabled")) {
      throw new Error(
        'Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute'
      );
    }
  } else {
    throw new Error('Invalid "target" value, use a valid Element');
  }

  select(target);

  try {
    succeeded = document.execCommand("copy");
  } catch (err) {
    succeeded = false;
  }
  if (trigger) {
    trigger.focus();
  }
  document.activeElement.blur();
  window.getSelection().removeAllRanges();
  return succeeded;
}

export async function writeToClipboard(value) {
  // Prefer async Clipboard API on secure contexts (https / localhost)
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(value);
    return;
  }

  // Fallback for older browsers / non-HTTPS
  const ta = document.createElement("textarea");
  ta.value = value;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  ta.style.top = "-9999px";
  document.body.appendChild(ta);

  // Some mobile browsers need focus
  ta.focus();
  ta.select();

  const ok = document.execCommand("copy");
  document.body.removeChild(ta);
  if (!ok) throw new Error("execCommand copy failed");
}
